module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.getBlockModifiers()
  }, [_c('div', {
    class: [_vm.block + '-text']
  }, [_vm._v(_vm._s(_vm.text))]), _vm._v(" "), _c('div', {
    class: [_vm.block + '-linkText']
  }, [(_vm.data.route == 'back') ? _c('div', {
    class: [_vm.block + '-link']
  }, [_vm._v("\n      " + _vm._s(_vm.linkText) + "\n    ")]) : (_vm.externalLink) ? _c('a', {
    class: [_vm.block + '-link'],
    attrs: {
      "href": _vm.externalLink
    }
  }, [_vm._v(_vm._s(_vm.linkText))]) : _c('router-link', {
    class: [_vm.block + '-link'],
    attrs: {
      "to": _vm.route
    },
    nativeOn: {
      "click": function($event) {
        _vm.closeMobileMenu()
      }
    }
  }, [_vm._v("\n      " + _vm._s(_vm.linkText) + "\n    ")])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cb839920","buble":{"objectAssign":"Object.assign"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/blocks/TextLink.vue
// module id = 400
// module chunks = 0